import { observer } from 'mobx-react';
import React, { useState, useRef, useEffect } from 'react';
import s from './index.less';
import { Icon } from '@/components';
import classnames from 'classnames';
import ViewBox, { sizeTypes } from '../../ViewBox';
import { useSize } from 'ahooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Mousewheel, Swiper as SwiperClass } from 'swiper/core';

SwiperCore.use([Mousewheel]);

interface SingleColumnLayoutProps {
  viewList: any;
}
export const SingleColumnLayout: React.FC<SingleColumnLayoutProps> = observer(
  (props: SingleColumnLayoutProps) => {
    const { viewList } = props;
    const [showPagenation, setShowPagenation] = useState<boolean>(false);
    const carouselRef = useRef(null);
    const pageRef = useRef(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(0);
    const [viewBoxSize, setViewBoxSize] = useState<{ width: number; height: number }>({
      width: 0,
      height: 0,
    });
    const swiperRef = React.useRef<any>();
    const viewboxContainerSize = useSize(carouselRef);
    const pageRefSize = useSize(pageRef);
    const pageSize = React.useMemo(() => {
      return limit ? Math.ceil(viewList.length / limit) : 1;
    }, [viewList, limit]);

    const calcBoxSize = () => {
      setShowPagenation(false);
      const width = viewboxContainerSize?.width!;
      const height = pageRefSize?.height!; // 滚动区域的高度
      const minHeight = (width * 9) / 16;
      const count = Math.floor(height / minHeight);
      let boxHeight;
      if (viewList.length <= count) {
        setShowPagenation(false);
        boxHeight = Math.floor((height - (viewList.length - 1) * 4) / viewList.length);
        setLimit(viewList.length);
      } else {
        setShowPagenation(true);
        setLimit(count);
        boxHeight = Math.floor((height - (count - 1) * 4 - 64) / count); //计算viewbox的高度，总高度-box之间的间距-上下分页器的高度
      }

      setViewBoxSize({
        width,
        height: boxHeight,
      });
    };

    const getMembers = (index: number) => {
      if (index !== pageSize - 1) {
        return viewList && viewList.slice(index * limit, limit * (index + 1));
      }
      return viewList.slice(-limit);
    };
    // 切换分页
    const nextPage = React.useCallback(async () => {
      if (currentPage !== pageSize && swiperRef.current) {
        swiperRef.current.slideNext();
        setCurrentPage(currentPage + 1);
      }
    }, [currentPage, pageSize, swiperRef]);

    const prevPage = React.useCallback(async () => {
      if (currentPage !== 1 && swiperRef.current) {
        swiperRef.current.slidePrev();
        setCurrentPage(currentPage - 1);
      }
    }, [currentPage, swiperRef]);

    const onSwiper = React.useCallback((swiper: any) => {
      swiperRef.current = swiper;
    }, []);

    const keyboardSlide = React.useCallback(async (pageIndex: number) => {
      setCurrentPage(pageIndex + 1);
    }, []);
    useEffect(() => {
      if (viewboxContainerSize?.width! < 488) {
        calcBoxSize();
      }
    }, [viewboxContainerSize, viewList.length]);

    // useEffect(() => {
    //   console.log('---viewList', viewList);
    //   console.log('---pageSize', pageSize);
    //   console.log('---limit', limit);
    //   console.log('---currentPage', currentPage);
    // }, [viewList, pageSize, limit, currentPage]);
    return (
      <div ref={pageRef} style={{ width: '100%', height: '100%' }}>
        {showPagenation && (
          <div className={classnames(s.up, currentPage === 1 ? s.disabled : '')} onClick={prevPage}>
            <Icon name="icon-arrow_solid_down_11" mode="symbol" size={16} className={s.icon}></Icon>
          </div>
        )}
        <div
          ref={carouselRef}
          className={s.singleWrapper}
          style={{ height: showPagenation ? 'calc(100% - 64px)' : '100%' }} // 减去上下分页器的高度
        >
          <Swiper
            longSwipes={false}
            direction="vertical"
            mousewheel={true}
            style={{ height: '100%', width: '100%' }}
            onSwiper={onSwiper}
            speed={0}
            spaceBetween={100}
            onSlideChange={({ realIndex }) => keyboardSlide(realIndex)}
          >
            {new Array(pageSize).fill(1).map((num, index) => {
              const members = getMembers(index);

              return (
                <SwiperSlide
                  key={index + num}
                  style={{
                    width: '100%',
                    height: showPagenation ? 'calc(100% - 64px)' : '100%',
                  }}
                >
                  {currentPage === index + 1 && ( // 是当前页的时候才去渲染
                    <>
                      {members.map((item: any, index: number) => {
                        return (
                          <div
                            className={classnames(
                              s.card,
                              index === viewList.length - 1 ? s.lastCard : ''
                            )}
                            key={index}
                          >
                            {
                              <div
                                key={item.yxUid + item.type}
                                className={s.boxItem}
                                style={{ width: viewBoxSize.width, height: viewBoxSize.height }}
                              >
                                <ViewBox
                                  key={item.yxUid + item.type}
                                  yxuid={String(item.yxUid)}
                                  type={item.type}
                                  sizeType={sizeTypes.full}
                                />
                              </div>
                            }
                          </div>
                        );
                      })}
                    </>
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        {showPagenation && (
          <div
            className={classnames(s.down, currentPage === pageSize ? s.disabled : '')}
            onClick={nextPage}
          >
            <Icon name="icon-arrow_solid_down_1" mode="symbol" size={16} className={s.icon}></Icon>
          </div>
        )}
      </div>
    );
  }
);
